import { Head } from "@inertiajs/react"

import type { TttChrome } from "@/components/ttt/types"
import Navbar from "@/components/ttt/Navbar"
import Footer from "@/components/ttt/Footer"

interface Props {
  chrome: TttChrome
  aboutHtml: string
  logoSrc: string
}

// Faithful React port of ttt/about.html.slim: TTT logo + the store's ActionText
// "about" body (rendered as HTML). The 3D mouse-tilt flourish is intentionally
// dropped (interaction-only); a static logo is shown.
export default function About({ chrome, aboutHtml, logoSrc }: Props) {
  return (
    <>
      <Head>
        <title>À propos — TTT</title>
      </Head>

      <Navbar chrome={chrome} />

      <div className="max-w-5xl mx-auto flex flex-col items-center px-6 pt-24 font-ttt">
        <div className="mt-12 flex justify-center w-1/2">
          <img src={logoSrc} alt="TTT" className="w-full" />
        </div>
        <div
          className="w-full md:px-0 pt-6 md:pt-0 text-justify text-sm leading-7 mb-12"
          dangerouslySetInnerHTML={{ __html: aboutHtml }}
        />
      </div>

      <Footer chrome={chrome} />
    </>
  )
}
